



























import { API_ENDPOINT } from '@/services/environment'
import axios from 'axios'
import { inject } from 'inversify-props'
import {
  InterviewsClient,
  InterviewUsage,
  List,
  MinimalInterviewDto
} from 'ritem-common'
import { Component, Vue } from 'vue-property-decorator'

@Component({ components: { List } })
export default class OnboardingOverview extends Vue {
  usages = [InterviewUsage.General, InterviewUsage.B2B, InterviewUsage.B2C]
  InterviewUsage = InterviewUsage
  @inject()
  interviewsClient: InterviewsClient

  interviewsClient2: InterviewsClient

  fields: any[] = [
    {
      key: 'name',
      label: 'Interview',
      sortable: true
    }
  ]

  async created() {
    // Bug: inject does not work, returns null
    this.interviewsClient2 = new InterviewsClient(API_ENDPOINT, axios)
  }

  toDetail(item: MinimalInterviewDto) {
    this.$router.push({
      name: 'onboarding-detail',
      params: { id: item.slugName }
    })
  }
}
